module.exports = __webpack_public_path__ + "media/images/expert__kay-voser-1f5f3a3e29be91c9b7385ad194b62ee2.png";